import axiosInstance from '../utils/axiosConfig';

export const fetchOperationsManagers = async () => {
  try {
    const response = await axiosInstance.get('/api/operations-managers/');
    return response.data;
  } catch (error) {
    console.error('Error fetching operations managers:', error);
    throw error;
  }
}; 